<template>
  <div>
    <div class="position-relative mb-3">
      <section class="section-profile-cover section-shaped my-0">
        <div class="shape shape-style-1 shape-yellowdark shape-skew alpha-4">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </section>
      <section class="section-skew">
        <div class="container-section">
          <card shadow class="section-home">
            <div class="row row-grid align-items-center">
              <div
                class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
              >
                <div class="title-product">
                  <h3>
                    فاصله از سیستم‌های قدیمی و سنتی به مدرن و کارآمد را با سرمد
                    طی کنید
                  </h3>
                  <p>
                    در دنیایی که به روز بودن در زمینه دانش و فن، حرف اول را در
                    رقابت و تجارت می‌زند؛ ارتباط و تجارت الکترونیک مطرح می‌باشد
                    که با داشتن سایت، بدون محدودیت زمانی و مکانی آماده‌ی خدمات
                    به کاربر می باشید.
                  </p>
                  <p>
                    امید است تخصص و تجربه ما شما را در عرصه‌ی جهانی شدن یاری
                    نماید.
                  </p>
                  <base-button
                    type="navyDark"
                    round
                    block
                    size="md"
                    @click="scrollToServices"
                  >
                    مشاهده خدمات
                  </base-button>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div class="img-main-page">
                  <img src="img/service/Low code development-pana.svg" alt="" />
                </div>
              </div>
            </div>
          </card>
        </div>
      </section>
    </div>
    <section ref="servicesSection">
      <div class="container-section">
        <div class="box-items-help">
          <b-row>
            <b-col
              cols="12"
              xl="4"
              lg="6"
              md="12"
              sm="12"
              xs="12"
              :class="[
                'box-card-service',
                cardVisible[0] ? 'visible' : 'hidden',
              ]"
            >
              <card class="shadow-lg--hover card-service">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="text-place">
                    <h5>طراحی و توسعه وب</h5>
                    <p>
                      طراحی وب سایت به مهارت و فرایند ساخت و راه اندازی صفحات وب
                      گفته می شود. وب سایت کسب و کار و برند شما، ویترینی برای
                      معرفی خدمات و محصولات ارائه شده توسط شماست. از این رو این
                      ویترین هرچه جذاب‌تر و بی‌نقص‌تر باشد، احتمال دیده شدن کسب
                      و کار و برند شما بیشتر است.
                    </p>
                  </div>
                </b-col>
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="img-place">
                    <img src="img/service/Cross-platform software-bro.svg" />
                  </div>
                </b-col>
              </card>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="6"
              md="12"
              sm="12"
              xs="12"
              :class="[
                'box-card-service',
                cardVisible[1] ? 'visible' : 'hidden',
              ]"
            >
              <card class="shadow-lg--hover card-service">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="img-place">
                    <img src="img/service/Software engineer-cuate.svg" />
                  </div>
                </b-col>
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="text-place">
                    <h5>طراحی و توسعه اپلیکیشن</h5>
                    <p>
                      اپلیکیشن موبایل برای استفاده های خاصی طراحی می شود و هر
                      سازمانی می‌تواند بنا به نیاز خود یک اپلیکیشن مخصوص به خود
                      را تولید و طراحی نماید. اپلیکیشن تعداد بازدیدهای هر کاربر
                      از محصولات شما را افزایش می‌دهد و می‌تواند آنها را تبدیل
                      به مشتریان وفادار شما کند.
                    </p>
                  </div>
                </b-col>
              </card>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="6"
              md="12"
              sm="12"
              xs="12"
              :class="[
                'box-card-service',
                cardVisible[2] ? 'visible' : 'hidden',
              ]"
            >
              <card class="shadow-lg--hover card-service">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="text-place">
                    <h5>خدمات اتوماسیون</h5>
                    <p>
                      سیستم اتوماسیون اداری یک سیستم اطلاعاتی مبتنی بر کامپیو‌تر
                      است که وظیفه جمع‌آوری، ذخیره و توزیع مستندات، پیام‌های
                      الکترونیک و سایر فرم‌های ارتباطات اداری را بین افراد،
                      گروه‌های کاری و سازمان‌ها بر عهده دارد. بخش‌هایی از این
                      سیستم‌ها عموما شامل نرم‌افزارهای پردازش کلمه، تصویر برداری
                      مستندات، تقویم و غیره است.
                    </p>
                  </div>
                </b-col>
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="img-place">
                    <img src="img/service/Cross.svg" />
                  </div>
                </b-col>
              </card>
            </b-col>

            <b-col
              cols="12"
              xl="6"
              lg="6"
              md="12"
              sm="12"
              xs="12"
              :class="[
                'box-card-service',
                cardVisible[3] ? 'visible' : 'hidden',
              ]"
            >
              <card class="shadow-lg--hover card-service-last">
                <b-row>
                  <b-col cols="12" xl="6" lg="12" md="12" sm="12" xs="12">
                    <div class="text-place">
                      <h5>طراحی گرافیکی و شبکه‌های مجازی</h5>
                      <p>
                        طراحی گرافیک یعنی هنر برقراری ارتباط بصری از طریق
                        عکس‌های متنی، نمادها و کارهای هنری که وظیفه انجام آنها
                        بر عهده‌ی یک طراح گرفیک است. یک برند، رابطه مستقیم بین
                        یک کسب و کار یا سازمان با مخاطبان آن است. هویت یک برند،
                        نحوه‌ی برقراری ارتباط یک سازمان با شخصیت، لحن و ذات،
                        همینطور خاطرات، احساسات و تجربه‌هایش است. طراحی گرافیک
                        هویت بصری، دقیقا به این شکل است: عناصر بصری هویت برند که
                        به عنوان وجهه‌ی یک برند در برقراری ارتباط با خصوصیاتی
                        نامشهود از طریق تصاویر، اشکال و رنگ‌ها، عمل می‌کند.
                      </p>
                    </div>
                  </b-col>
                  <b-col cols="12" xl="6" lg="12" md="12" sm="12" xs="12">
                    <div class="img-place">
                      <img src="img/service/UI-UX differences-cuate.svg" />
                    </div>
                  </b-col>
                </b-row>
              </card>
            </b-col>
            <b-col
              cols="12"
              xl="6"
              lg="6"
              md="12"
              sm="12"
              xs="12"
              :class="[
                'box-card-service',
                cardVisible[4] ? 'visible' : 'hidden',
              ]"
            >
              <card class="shadow-lg--hover card-service-last">
                <b-row>
                  <b-col cols="12" xl="6" lg="12" md="12" sm="12" xs="12">
                    <div class="text-place">
                      <h5>سامانه‌های آموزشی</h5>
                      <p>
                        با توجه به رشد چشمگیر کسب و کارهای آموزشی و رقابت
                        روزافزون در صنعت آموزش، بی تردید استفاده از فرآیندهای
                        سرویس کلاس مجازی دیگر یه گزینه نیست و میتواند تنها راه
                        چاره باشد. با توجه به اینکه گرایش به سمت خودکارسازی
                        فرآیندها و کاهش خطای انسانی هر روز در حال افزایش است،
                        نرم افزارهای یکپارچه سرمد این چالش را برای آموزشگاه‌ها و
                        مدیران منابع انسانی سازمان‌ها حل نموده‌اند. این سیستم‌ها
                        قابلیت اتصال و یکپارچه سازی با سایر نرم افزارهای سازمان
                        شما را نیز دارا هستند
                      </p>
                    </div>
                  </b-col>
                  <b-col cols="12" xl="6" lg="12" md="12" sm="12" xs="12">
                    <div class="img-place">
                      <img src="img/service/Learning-cuate.svg" />
                    </div>
                  </b-col>
                </b-row>
              </card>
            </b-col>
          </b-row>
        </div>
      </div>
    </section>

    <!-- <section class="section">
      <div class="container-section">
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
          sm="12"
          xs="12"
          class="section-Popular-tours"
        >
          <h3>نظرات مشتریان</h3>
        </b-col>
        <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
          <hooper
            :settings="hooperSettings"
            :autoPlay="true"
            :playSpeed="2000"
            style="height:400px"
          >
            <slide
              v-for="(item, index) in listComment"
              :key="index"
              class="slider-fav"
            >
              <card shadow class="shadow-lg--hover mt-5 card-user">
                <span>
                  {{ item.content }}
                </span>
                <div class="pt-4 text-center footer-card-user">
                  <div class="title-section">
                    <h6 class="d-block mb-1">{{ item.name }}</h6>
                  </div>
                </div>
              </card>
            </slide>
          </hooper>
        </b-col>
      </div>
    </section> -->

    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
// import { Hooper, Slide } from 'hooper';
import "hooper/dist/hooper.css";
import {
  Hooper,
  Slide,
  Progress as HooperProgress,
  Pagination as HooperPagination,
  Navigation as HooperNavigation,
} from "hooper";
export default {
  name: "Services",
  components: {
    Hooper,
    Slide,
    HooperProgress,
    HooperPagination,
    HooperNavigation,
  },
  data() {
    return {
      showScrollButton: false,
      slide: 0,
      sliding: null,
      cardVisible: [false, false, false, false, false],
      imgVisible: [false, false, false, false, false],
      listComment: [
        {
          content:
            "خدمات کارلنسر خیلی برای کسب و کار من مفید بوده . من به عنوان کسی که از خارج از کشور برای کسب و کار خودم نیاز به فعالیت و همکاری با متخصصین داخلی رو دارم و امکان داشتن دفتر کار فیزیکی در داخل رو ندارم کارلنسر امکان خیلی خوبی رو فراهم کرده که به متخصصای داخلی وصل شم و کسب و کارم رو در سراسر دنیا توسعه بدم. به عقیده من دورکاری و برونسپاری کارها فرصت رشد خوبی رو برای کسب و کارها و کارفرماها ایجاد میکنه. ",
          name: "امیر مسعود ناصری",
        },
        {
          content:
            "خدمات کارلنسر خیلی برای کسب و کار من مفید بوده . من به عنوان کسی که از خارج از کشور برای کسب و کار خودم نیاز به فعالیت و همکاری با متخصصین داخلی رو دارم و امکان داشتن دفتر کار فیزیکی در داخل رو ندارم کارلنسر امکان خیلی خوبی رو فراهم کرده که به متخصصای داخلی وصل شم و کسب و کارم رو در سراسر دنیا توسعه بدم. به عقیده من دورکاری و برونسپاری کارها فرصت رشد خوبی رو برای کسب و کارها و کارفرماها ایجاد میکنه. ",
          name: "فرانک مقیمی ",
        },
        {
          content:
            "خدمات کارلنسر خیلی برای کسب و کار من مفید بوده . من به عنوان کسی که از خارج از کشور برای کسب و کار خودم نیاز به فعالیت و همکاری با متخصصین داخلی رو دارم و امکان داشتن دفتر کار فیزیکی در داخل رو ندارم کارلنسر امکان خیلی خوبی رو فراهم کرده که به متخصصای داخلی وصل شم و کسب و کارم رو در سراسر دنیا توسعه بدم. به عقیده من دورکاری و برونسپاری کارها فرصت رشد خوبی رو برای کسب و کارها و کارفرماها ایجاد میکنه. ",
          name: "امیر مسعود ناصری",
        },
        {
          content:
            "خدمات کارلنسر خیلی برای کسب و کار من مفید بوده . من به عنوان کسی که از خارج از کشور برای کسب و کار خودم نیاز به فعالیت و همکاری با متخصصین داخلی رو دارم و امکان داشتن دفتر کار فیزیکی در داخل رو ندارم کارلنسر امکان خیلی خوبی رو فراهم کرده که به متخصصای داخلی وصل شم و کسب و کارم رو در سراسر دنیا توسعه بدم. به عقیده من دورکاری و برونسپاری کارها فرصت رشد خوبی رو برای کسب و کارها و کارفرماها ایجاد میکنه. ",
          name: "علیرضا محمد ولی",
        },
        {
          content:
            "خدمات کارلنسر خیلی برای کسب و کار من مفید بوده . من به عنوان کسی که از خارج از کشور برای کسب و کار خودم نیاز به فعالیت و همکاری با متخصصین داخلی رو دارم و امکان داشتن دفتر کار فیزیکی در داخل رو ندارم کارلنسر امکان خیلی خوبی رو فراهم کرده که به متخصصای داخلی وصل شم و کسب و کارم رو در سراسر دنیا توسعه بدم. به عقیده من دورکاری و برونسپاری کارها فرصت رشد خوبی رو برای کسب و کارها و کارفرماها ایجاد میکنه. ",
          name: "فرانک  ناصری",
        },
        {
          content:
            "خدمات کارلنسر خیلی برای کسب و کار من مفید بوده . من به عنوان کسی که از خارج از کشور برای کسب و کار خودم نیاز به فعالیت و همکاری با متخصصین داخلی رو دارم و امکان داشتن دفتر کار فیزیکی در داخل رو ندارم کارلنسر امکان خیلی خوبی رو فراهم کرده که به متخصصای داخلی وصل شم و کسب و کارم رو در سراسر دنیا توسعه بدم. به عقیده من دورکاری و برونسپاری کارها فرصت رشد خوبی رو برای کسب و کارها و کارفرماها ایجاد میکنه. ",
          name: "فرانک مقیمی ",
        },
        {
          content:
            "خدمات کارلنسر خیلی برای کسب و کار من مفید بوده . من به عنوان کسی که از خارج از کشور برای کسب و کار خودم نیاز به فعالیت و همکاری با متخصصین داخلی رو دارم و امکان داشتن دفتر کار فیزیکی در داخل رو ندارم کارلنسر امکان خیلی خوبی رو فراهم کرده که به متخصصای داخلی وصل شم و کسب و کارم رو در سراسر دنیا توسعه بدم. به عقیده من دورکاری و برونسپاری کارها فرصت رشد خوبی رو برای کسب و کارها و کارفرماها ایجاد میکنه. ",
          name: "فرانک مقیمی ",
        },
        {
          content:
            "خدمات کارلنسر خیلی برای کسب و کار من مفید بوده . من به عنوان کسی که از خارج از کشور برای کسب و کار خودم نیاز به فعالیت و همکاری با متخصصین داخلی رو دارم و امکان داشتن دفتر کار فیزیکی در داخل رو ندارم کارلنسر امکان خیلی خوبی رو فراهم کرده که به متخصصای داخلی وصل شم و کسب و کارم رو در سراسر دنیا توسعه بدم. به عقیده من دورکاری و برونسپاری کارها فرصت رشد خوبی رو برای کسب و کارها و کارفرماها ایجاد میکنه. ",
          name: "امیر مسعود ناصری",
        },
        {
          content:
            "خدمات کارلنسر خیلی برای کسب و کار من مفید بوده . من به عنوان کسی که از خارج از کشور برای کسب و کار خودم نیاز به فعالیت و همکاری با متخصصین داخلی رو دارم و امکان داشتن دفتر کار فیزیکی در داخل رو ندارم کارلنسر امکان خیلی خوبی رو فراهم کرده که به متخصصای داخلی وصل شم و کسب و کارم رو در سراسر دنیا توسعه بدم. به عقیده من دورکاری و برونسپاری کارها فرصت رشد خوبی رو برای کسب و کارها و کارفرماها ایجاد میکنه. ",
          name: "علیرضا محمد ولی",
        },
      ],

      hooperSettings: {
        infiniteScroll: true,
        centerMode: true,
        autoPlay: true,
        playSpeed: 3000,
        breakpoints: {
          2400: {
            itemsToShow: 5,
          },
          1800: {
            itemsToShow: 4,
          },
          1100: {
            itemsToShow: 3,
          },
          900: {
            itemsToShow: 3,
          },
          600: {
            itemsToShow: 2,
          },
          400: {
            itemsToShow: 1,
          },
        },
      },
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
    scrollToServices() {
      const servicesSection = this.$refs.servicesSection;
      if (servicesSection) {
        servicesSection.scrollIntoView({ behavior: "smooth" });
      }
    },
    animateCards() {
      this.cardVisible.forEach((_, index) => {
        setTimeout(() => {
          this.$set(this.cardVisible, index, true);
        }, index * 1000);
      });
    },
    animateimg() {
      this.imgVisible.forEach((_, index) => {
        setTimeout(() => {
          this.$set(this.imgVisible, index, true);
        }, index * 1000);
      });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.animateCards();
    this.animateimg();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss">
.svg-bg {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.box-items-help {
  margin-top: 20px;

  .img-place {
    width: 100%;
    height: 180px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .text-place {
    h5 {
      color: #f0a500;
      font-size: 15px;
      margin-bottom: 15px;

      @media screen and (max-width: 768px) {
        font-size: 14px;
        margin-top: 10px;
      }
    }

    p {
      color: #525f7f;
      font-size: 13px;
    }
  }
}
.hidden {
  opacity: 0;
  transform: translateX(100%);
  transition: opacity 1s ease, transform 1s ease;
}

.visible {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 1s ease, transform 1s ease;
}
</style>
